/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

document.addEventListener('DOMContentLoaded', function () {
  setTimeout(() => {
    const stickyElement = document.querySelector('.Vtl-StickyAddToCart');
    const stickyAtc = document.querySelector('#bundle-sticky_submit');
    

    

    if (stickyElement) {
      stickyElement.style.zIndex = '99991';
    }

    if (stickyAtc) {
      stickyAtc.style.color = '#000';
    }
  }, 1000);

  // const popoverSel = document.querySelector('.Popover');

  // if (popoverSel) {
  //     popoverSel.style.zIndex = '999999';
  //   }
});
